import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { Button } from '../components/Button';
import { CheckCircleIcon } from 'lucide-react';
export function DonatePage() {
  const [donationAmount, setDonationAmount] = useState<number | string>(100);
  const [customAmount, setCustomAmount] = useState(false);
  const [donorName, setDonorName] = useState('');
  const [donorEmail, setDonorEmail] = useState('');
  const [donorPhone, setDonorPhone] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleAmountSelect = (amount: number) => {
    setDonationAmount(amount);
    setCustomAmount(false);
  };
  const handleCustomAmount = () => {
    setDonationAmount('');
    setCustomAmount(true);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      // Reset form after successful submission
      setDonationAmount(100);
      setCustomAmount(false);
      setDonorName('');
      setDonorEmail('');
      setDonorPhone('');
      setIsAnonymous(false);
      setPaymentMethod('card');
    }, 1500);
  };
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-466">
      <Header data-id="element-467" />
      <main className="w-full font-sans" data-id="element-468">
        <PageHeader title="Donate to Our Cause" subtitle="Your contribution helps us continue our mission of uplifting lives" badgeText="SUPPORT OUR WORK" bgColor="bg-gradient-to-r from-sfrr-pink to-sfrr-green" data-id="element-469" />
        <section className="py-16 bg-white" data-id="element-470">
          <div className="container mx-auto px-4" data-id="element-471">
            <div className="max-w-3xl mx-auto" data-id="element-472">
              {!isSubmitted ? <>
                  <div className="text-center mb-8" data-id="element-473">
                    <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-474">
                      Make a Donation
                    </h2>
                    <p className="text-charcoal/80" data-id="element-475">
                      Your support enables us to continue our work in
                      transforming communities across Nigeria.
                    </p>
                  </div>
                  <form onSubmit={handleSubmit} className="space-y-8" data-id="element-476">
                    {/* Donation Amount */}
                    <div data-id="element-477">
                      <label className="block text-lg font-medium text-charcoal mb-4" data-id="element-478">
                        Select Donation Amount
                      </label>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-479">
                        {[50, 100, 250, 500].map(amount => <button key={amount} type="button" className={`py-3 px-4 rounded-md border-2 transition-all ${donationAmount === amount && !customAmount ? 'border-sfrr-pink bg-sfrr-pink/10 text-sfrr-pink' : 'border-gray-200 hover:border-sfrr-pink/50'}`} onClick={() => handleAmountSelect(amount)} data-id="element-480">
                            ₦{amount.toLocaleString()}
                          </button>)}
                      </div>
                      <div className="mt-4" data-id="element-481">
                        <button type="button" className={`py-3 px-4 rounded-md border-2 transition-all w-full ${customAmount ? 'border-sfrr-pink bg-sfrr-pink/10 text-sfrr-pink' : 'border-gray-200 hover:border-sfrr-pink/50'}`} onClick={handleCustomAmount} data-id="element-482">
                          Custom Amount
                        </button>
                        {customAmount && <div className="mt-3" data-id="element-483">
                            <div className="relative" data-id="element-484">
                              <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-charcoal/60" data-id="element-485">
                                ₦
                              </span>
                              <input type="number" className="w-full pl-8 pr-4 py-3 rounded-md border-2 border-gray-200 focus:border-sfrr-pink focus:outline-none" placeholder="Enter amount" value={donationAmount} onChange={e => setDonationAmount(e.target.value)} min="1" required data-id="element-486" />
                            </div>
                          </div>}
                      </div>
                    </div>
                    {/* Donor Information */}
                    <div data-id="element-487">
                      <label className="block text-lg font-medium text-charcoal mb-4" data-id="element-488">
                        Your Information
                      </label>
                      <div className="space-y-4" data-id="element-489">
                        <div data-id="element-490">
                          <label className="block text-sm font-medium text-charcoal/80 mb-1" data-id="element-491">
                            Full Name
                          </label>
                          <input type="text" className="w-full px-4 py-3 rounded-md border-2 border-gray-200 focus:border-sfrr-pink focus:outline-none" placeholder="Enter your full name" value={donorName} onChange={e => setDonorName(e.target.value)} required={!isAnonymous} disabled={isAnonymous} data-id="element-492" />
                        </div>
                        <div data-id="element-493">
                          <label className="block text-sm font-medium text-charcoal/80 mb-1" data-id="element-494">
                            Email Address
                          </label>
                          <input type="email" className="w-full px-4 py-3 rounded-md border-2 border-gray-200 focus:border-sfrr-pink focus:outline-none" placeholder="Enter your email address" value={donorEmail} onChange={e => setDonorEmail(e.target.value)} required data-id="element-495" />
                        </div>
                        <div data-id="element-496">
                          <label className="block text-sm font-medium text-charcoal/80 mb-1" data-id="element-497">
                            Phone Number (Optional)
                          </label>
                          <input type="tel" className="w-full px-4 py-3 rounded-md border-2 border-gray-200 focus:border-sfrr-pink focus:outline-none" placeholder="Enter your phone number" value={donorPhone} onChange={e => setDonorPhone(e.target.value)} data-id="element-498" />
                        </div>
                        <div className="flex items-center" data-id="element-499">
                          <input type="checkbox" id="anonymous" className="w-5 h-5 text-sfrr-pink border-gray-300 rounded focus:ring-sfrr-pink" checked={isAnonymous} onChange={e => setIsAnonymous(e.target.checked)} data-id="element-500" />
                          <label htmlFor="anonymous" className="ml-2 text-charcoal" data-id="element-501">
                            Make this donation anonymous
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* Payment Method */}
                    <div data-id="element-502">
                      <label className="block text-lg font-medium text-charcoal mb-4" data-id="element-503">
                        Payment Method
                      </label>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-504">
                        <button type="button" className={`py-3 px-4 rounded-md border-2 transition-all flex items-center justify-center ${paymentMethod === 'card' ? 'border-sfrr-pink bg-sfrr-pink/10 text-sfrr-pink' : 'border-gray-200 hover:border-sfrr-pink/50'}`} onClick={() => setPaymentMethod('card')} data-id="element-505">
                          <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-506">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-507" />
                          </svg>
                          Credit Card
                        </button>
                        <button type="button" className={`py-3 px-4 rounded-md border-2 transition-all flex items-center justify-center ${paymentMethod === 'bank' ? 'border-sfrr-pink bg-sfrr-pink/10 text-sfrr-pink' : 'border-gray-200 hover:border-sfrr-pink/50'}`} onClick={() => setPaymentMethod('bank')} data-id="element-508">
                          <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-509">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" data-id="element-510" />
                          </svg>
                          Bank Transfer
                        </button>
                        <button type="button" className={`py-3 px-4 rounded-md border-2 transition-all flex items-center justify-center ${paymentMethod === 'mobile' ? 'border-sfrr-pink bg-sfrr-pink/10 text-sfrr-pink' : 'border-gray-200 hover:border-sfrr-pink/50'}`} onClick={() => setPaymentMethod('mobile')} data-id="element-511">
                          <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-512">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" data-id="element-513" />
                          </svg>
                          Mobile Money
                        </button>
                      </div>
                    </div>
                    {/* Submit Button */}
                    <div className="pt-4" data-id="element-514">
                      <Button variant="primary" size="lg" type="submit" fullWidth disabled={isSubmitting} data-id="element-515">
                        {isSubmitting ? 'Processing...' : `Donate ${typeof donationAmount === 'number' || donationAmount ? `₦${Number(donationAmount).toLocaleString()}` : ''}`}
                      </Button>
                      <p className="text-center mt-4 text-sm text-charcoal/60" data-id="element-516">
                        Your donation is secure and encrypted. By donating, you
                        agree to our terms of service and privacy policy.
                      </p>
                    </div>
                  </form>
                </> : <div className="text-center py-8 bg-warm-ivory rounded-lg shadow-soft animate-fadeIn" data-id="element-517">
                  <div className="flex justify-center mb-4" data-id="element-518">
                    <div className="bg-sfrr-green/10 w-16 h-16 rounded-full flex items-center justify-center" data-id="element-519">
                      <CheckCircleIcon className="h-10 w-10 text-sfrr-green" data-id="element-520" />
                    </div>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-521">
                    Thank You for Your Donation!
                  </h2>
                  <p className="text-charcoal/80 mb-6 max-w-md mx-auto" data-id="element-522">
                    Your generous contribution will help us continue our mission
                    to uplift lives and transform communities across Nigeria.
                  </p>
                  <p className="text-charcoal/80 mb-8" data-id="element-523">
                    A receipt has been sent to your email address.
                  </p>
                  <Button variant="primary" onClick={() => setIsSubmitted(false)} data-id="element-524">
                    Make Another Donation
                  </Button>
                </div>}
            </div>
          </div>
        </section>
        {/* Impact of Donations */}
        <section className="py-16 bg-warm-ivory" data-id="element-525">
          <div className="container mx-auto px-4" data-id="element-526">
            <div className="text-center mb-12" data-id="element-527">
              <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-528">
                The Impact of Your Donation
              </h2>
              <p className="max-w-2xl mx-auto text-charcoal/80" data-id="element-529">
                See how your contribution helps transform lives and communities.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-530">
              <div className="bg-white rounded-lg p-6 shadow-soft text-center" data-id="element-531">
                <div className="text-3xl font-bold text-sfrr-pink mb-2" data-id="element-532">
                  ₦5,000
                </div>
                <p className="text-charcoal/80" data-id="element-533">
                  Provides clean water to a family for a month
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-soft text-center" data-id="element-534">
                <div className="text-3xl font-bold text-sfrr-blue mb-2" data-id="element-535">
                  ₦25,000
                </div>
                <p className="text-charcoal/80" data-id="element-536">
                  Funds educational materials for 10 students
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-soft text-center" data-id="element-537">
                <div className="text-3xl font-bold text-sfrr-green mb-2" data-id="element-538">
                  ₦100,000
                </div>
                <p className="text-charcoal/80" data-id="element-539">
                  Supports agricultural training for a community
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-540" />
    </div>;
}